import React from 'react';
import classNames from 'classnames';

import css from './IconQuotes.module.css';

/**
 * Alert icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} SVG icon
 */
const IconQuotes = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="30"
      fill="none"
      viewBox="0 0 40 30"
    >
      <path
        fill="#211737"
        d="M22.4 12.6v16.8h16.8V12.6c0-5.28-4.32-12-9.6-12h-4.8l2.4 4.8s4.8 0 4.8 7.2zm-21.6 0v16.8h16.8V12.6c0-5.28-4.32-12-9.6-12H3.2l2.4 4.8s4.8 0 4.8 7.2z"
      ></path>
    </svg>
  );
};

export default IconQuotes;
